<template>
  <v-data-table
    :headers="headers"
    :items="getItems"
    :search="search"
    sort-by="nombre"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar..."
          single-line
          hide-details
        ></v-text-field>
        <v-btn color="green" small outlined @click="descargarExcel"><v-icon color="green">mdi-microsoft-excel</v-icon></v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="$router.push({ name: 'CrearEditarPersona'})"
              >NUEVO</v-btn
            >
       
      </v-toolbar>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small  class="mr-2"  @click="$router.push(`/clientes/creareditar/${item.idpersona}`)" >
        mdi-pencil
      </v-icon>
      <v-icon small @click="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Recargar</v-btn>
    </template>
  </v-data-table>
</template>

<script>

import Swal from "sweetalert2";
import {json2excel} from 'js2excel';
export default {
  
  data: () => ({
    title: "CLIENTES",
    search: "",
    estado: false,
    dialog: false,
    headers: [
      { text: "Codigo", align: "center", value: "codigo" },
      { text: "Nit", align: "center", value: "nit" },
      { text: "Nombre", value: "nombre",width: '25%' },
      { text: "Direccion", value: "direccion",width: '40%'  },
      { text: "Telefono", align: "center", value: "telefono" },
      { text: "Correo", align: "center", value: "email" },
      { text: "Actions", align: "center", value: "actions", sortable: false },
    ],
    
  }),

  computed: {
    
    getItems(){
        return this.$store.getters.getAllClientes
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  async created() {
   await this.initialize();
  },

  methods: {
    async initialize() {
      await this.$store.dispatch('setClientes')       
    },
    navegar(item){
      if(item){
        this.$router.push({ name: 'CrearEditarPersona', params: { username: item.idpersona } })
      }else{
        this.$router.push({ name: 'CrearEditarPersona'})
      }
    },
    deleteItem(item) {
      Swal.fire({
        title: "Esta Seguro?",
        text: "El registro será ELIMINADO!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, Eliminar!",
        cancelButtonText: "Cancelar!",
      }).then(async (result) => {
        if (result.isConfirmed) {
           item.estado = "Eliminado"
           await this.$store.dispatch('updateCliente',item)
           await this.initialize() 
        }
      });
    },

    descargarExcel(){

        const data = this.getItems
        try {
            json2excel({
                data,
                name: 'Reporte_ClientesyProveedores',
                formateDate: 'yyyy/mm/dd'
            });
        } catch (e) {
            console.error('export error');
        }
      },
    //Notificaciones Swal
    alertDone() {
     
    },
  },
};
</script>
